module.exports = __webpack_public_path__ + "static/media/cam_03_FFF-min.7f87cc52.jpg";